import { ILogger } from './types';

export default class MultiTransportLogger implements ILogger {
  private loggers: ILogger[] = [];

  register(logger: ILogger) {
    this.loggers.push(logger);
  }

  public debug = (msg?: string, ...optionalParams: any[]): void => {
    this.loggers.forEach((logger) => {
      logger.debug(msg, ...optionalParams);
    });
  };

  public info = (msg?: string, ...optionalParams: any[]): void => {
    this.loggers.forEach((logger) => {
      logger.info(msg, ...optionalParams);
    });
  };

  public warn = (msg?: string, ...optionalParams: any[]): void => {
    this.loggers.forEach((logger) => {
      logger.warn(msg, ...optionalParams);
    });
  };

  public error = (err: Error, ...optionalParams: any[]): void => {
    this.loggers.forEach((logger) => {
      logger.error(err, ...optionalParams);
    });
  };

  public trace = (msg?: string, ...optionalParams: any[]): void => {
    this.loggers.forEach((logger) => {
      logger.trace(msg, ...optionalParams);
    });
  };
}
